import { Grid, Hidden } from '@material-ui/core';
import MyContractInfo from 'components/MyContractInfo/AUTOContractInfo';
import MyContractsTabs from 'components/MyContractsTabs';
import messages from 'containers/AutoDetailsPage/messages';
import KnowMoreAboutContract from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import MyguaranteesBloc from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc';
import MySupportServices from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MySupportServices';
import DownloadFileAutoContracts from 'containers/AutoDetailsPage/MyContractsBloc/DownloadFileAutoContracts';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getDetailContract } from 'store/contract/actions';
import {
  getContractAutoSelector,
  getDetailsContractSelector,
  getFilesContractAutoSelector,
  getGrantiesContractAutoSelector,
  getIsLoadingDetailContractSelector,
  getServicesContractAutoSelector,
} from 'store/contract/selectors';
import { CONTRACT_STATUSES } from 'utils/globalConst';

const MyContractAndGarantiesTab = (props: {
  contractsAuto: {
    autoBrand: string;
    contractNumber: string;
    deadline: string;
    status: string;
    effectiveDate: string;
    veh_registration: string;
    circulationDate: string;
    product: string;
  }[];
  intl: IntlShape;
  contractPrime: string;
  getDetailContract: Function;
  isLoadingDetailContract: boolean;
  files: [];
  servicesAssitance: [];
  garanties: [];
}) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.AUTO_DETAILS}
    label="Mes contrats_Tab 2_Mes contrats"
  >
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Hidden xsDown>
          <KnowMoreAboutContract />
        </Hidden>
        <MyContractsTabs
          tabItems={
            props.contractsAuto &&
            props.contractsAuto.map(
              /* istanbul ignore next */ (item: {
                autoBrand: string;
                contractNumber: string;
                deadline: string;
                status: string;
                effectiveDate: string;
                veh_registration: string;
                circulationDate: string;
                product: string;
              }) => ({
                label: item.autoBrand,
                contractNumber: item.contractNumber,
                circulationDate: item.circulationDate,
                content: (
                  <MyContractInfo
                    numPolice={item.contractNumber}
                    dateEffet={item.effectiveDate}
                    dateEcheance={item.deadline}
                    immatriculation={item.veh_registration}
                    produit={item.product}
                    tarif={props.contractPrime && props.contractPrime}
                    status={
                      item.status === CONTRACT_STATUSES.ACTIVE
                        ? 'success'
                        : 'error'
                    }
                    statusLabel={
                      item.status === CONTRACT_STATUSES.ACTIVE
                        ? translate({ ...messages.Actif }, props)
                        : translate({ ...messages.Encours }, props)
                    }
                  />
                ),
              }),
            )
          }
          getDetailContract={props.getDetailContract}
          isLoadingDetailContract={props.isLoadingDetailContract}
          category=""
          label=""
        />
      </Grid>
      <Grid item xs={12}>
        <MyguaranteesBloc
          garanties={props.garanties}
          isLoadingDetailContract={props.isLoadingDetailContract}
        />
      </Grid>
      <Grid item xs={12}>
        <DownloadFileAutoContracts
          category={EVENT_CATEGORIES.AUTO_DETAILS}
          files={props.files}
        />
      </Grid>
      <Grid item xs={12}>
        <MySupportServices servicesAssitance={props.servicesAssitance} />
      </Grid>
    </Grid>
  </GaLoadHOC>
);

const mapStateToProps = createStructuredSelector<
  any,
  {
    contractsAuto: [];
    contractPrime: string;
    isLoadingDetailContract: boolean;
    files: [];
    servicesAssitance: [];
    garanties: [];
  }
>({
  contractsAuto: getContractAutoSelector,
  isLoadingDetailContract: getIsLoadingDetailContractSelector,
  contractPrime: getDetailsContractSelector,
  files: getFilesContractAutoSelector,
  servicesAssitance: getServicesContractAutoSelector,
  garanties: getGrantiesContractAutoSelector,
});
const mapDispatchToProps = {
  getDetailContract,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyContractAndGarantiesTab));
